import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-frequent-question',
    imports: [],
    templateUrl: './frequent-question.component.html',
    standalone: true,
    styleUrl: './frequent-question.component.scss'
})
export class FrequentQuestionComponent {
  @Input() question!: { question: string; answer: string };
  @Input() index!: number;

  faqOpen = false;

  ngOnInit() {
    this.faqOpen = this.index === 0; // первый элемент открыт, остальные закрыты
  }

  toggle() {
    this.faqOpen = !this.faqOpen;
  }
}
